export default "__VITE_ASSET__CgW5mGVx__"